var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  fill: "currentColor",
  viewBox: "0 0 455 455"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M455 212.5H242.5V0h-30v212.5H0v30h212.5V455h30V242.5H455z"
})));
export { SvgPlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIGZpbGw9ImN1cnJlbnRDb2xvciIgdmlld0JveD0iMCAwIDQ1NSA0NTUiPjxwYXRoIGQ9Ik00NTUgMjEyLjVIMjQyLjVWMGgtMzB2MjEyLjVIMHYzMGgyMTIuNVY0NTVoMzBWMjQyLjVINDU1eiIvPjwvc3ZnPg==";